import { render, staticRenderFns } from "./QuestionRules.Children.vue?vue&type=template&id=0d320b7d&"
import script from "./QuestionRules.Children.vue?vue&type=script&lang=js&"
export * from "./QuestionRules.Children.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports